<template>

    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="28px" height="28px"
	 viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">

<g>
	<g>
		<g>
			<g>
				<g>
					<g>
						<g>
							<path class="st0" d="M17.9,30c-0.1,0-0.1,0-0.2,0l-8.6-1.1c-0.4-0.1-0.8-0.3-1-0.6c-0.2-0.3-0.3-0.8-0.2-1.2l0.8-3.9
								C4.4,21.1,1.7,16.8,1.8,12C1.8,5.4,7.3,0,14,0l0.1,0c3,0,5.7,0.8,7.8,2.3c2.3,1.6,3.7,4,4.1,6.9l0.1,0.8c0,0.3,0,1.4,0,1.9
								l1.8,3.3v0c0.3,0.6,0.4,1.4,0,2c-0.3,0.6-0.9,1.1-1.6,1.2l-0.1,0v4.9c0,0.6-0.2,1.2-0.7,1.7c-0.5,0.5-1.1,0.7-1.8,0.7
								c0,0-0.2,0-2.5-0.2c-0.3,0-0.7-0.1-1.1-0.1l-0.9,3.4C19.2,29.5,18.6,30,17.9,30z M9.8,27l7.8,1l1.2-4.6l1.1,0.1
								c0.5,0,1.1,0.1,1.6,0.1c0.9,0.1,2.2,0.2,2.4,0.2c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.1-0.2,0.1-0.3l0-6.5l1.7-0.3
								c0.1,0,0.2-0.1,0.2-0.2c0-0.1,0-0.2,0-0.3v0l-2.1-3.7l0-0.2c0-0.7,0-1.7,0-1.9l-0.1-0.7c-0.3-2.3-1.5-4.2-3.4-5.6
								C19,2.6,16.7,1.9,14,1.9l-0.1,0C8.4,1.9,3.7,6.5,3.7,12.1c-0.1,4.3,2.5,8.1,6.4,9.7l0.7,0.3L9.8,27z"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
</g>
</svg>

</template>

<script>
    export default {
        name: "KH_svg"
    }
</script>





// WEBPACK FOOTER //
// src/common/components/svg/chapter/KH_svg.vue